import { createShowToolbarFunc } from '@tencent/exeditor3-core/dist/utils/toolbar.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
const clampHref = (href) => {
    let finalHref = href;
    if (finalHref.length > 28) {
        finalHref = `${finalHref.substring(0, 25)}...`;
    }
    return finalHref;
};
const createBubbleContainer = (plugin) => {
    const t = plugin.editor.t.bind(plugin.editor);
    const container = document.createElement('div');
    container.className = 'link-toolbar exeditor-toolbar';
    container.dataset.theme = 'basic';
    container.dataset.in = 'popover';
    Object.assign(container.style, {
        position: 'absolute',
        display: 'none',
    });
    container.addEventListener('mousedown', (ev) => {
        ev.preventDefault();
    });
    const linkItems = [
        {
            id: 'open',
            handle: () => plugin.open(),
            content: t('打开链接'),
            style: { 'font-size': '14px' },
        },
        {
            id: 'copy',
            handle: () => plugin.copy(),
            label: t('复制链接'),
            content: createIcon({
                name: 'copy',
                editor: plugin.editor,
                fallback: () => import('./icon.js').then((m) => m.copyLinkIcon),
            }),
        },
        {
            id: 'edit',
            handle: () => plugin.edit(),
            label: t('编辑链接'),
            content: createIcon({
                name: 'linkEdit; edit',
                editor: plugin.editor,
                fallback: () => import('./icon.js').then((m) => m.editLinkIcon),
            }),
        },
        {
            id: 'delete',
            handle: () => plugin.delete(),
            label: t('删除链接'),
            content: createIcon({
                name: 'unlink',
                editor: plugin.editor,
                fallback: () => import('./icon.js').then((m) => m.unlinkIcon),
            }),
        },
    ];
    const linkBtns = {};
    linkItems.forEach(({ id, content, handle, label, style }) => {
        const item = document.createElement('exeditor-toolbar-button');
        if (label) {
            item.label = label;
        }
        if (style) {
            Object.assign(item.style, style);
        }
        item.className = 'item';
        if (typeof content === 'string') {
            item.innerHTML = content;
        }
        else {
            item.appendChild(content);
        }
        item.addEventListener('click', handle);
        linkBtns[id] = item;
        container.appendChild(item);
    });
    return {
        bubble: container,
        updateLabel(id, href) {
            linkBtns[id].label = href;
        },
    };
};
export const createLinkBubbleToolbar = (editor, plugin) => {
    const { bubble, updateLabel } = createBubbleContainer(plugin);
    const show = createShowToolbarFunc(editor, bubble, {
        zIndex: 1,
    });
    const hide = () => {
        bubble.style.display = 'none';
    };
    const handleEditorChange = () => {
        const selection = editor.selection();
        if (selection.empty && plugin.isActive()) {
            const clampedHref = clampHref(plugin.getAttr('href'));
            updateLabel('open', clampedHref);
            show(selection.from);
        }
        else {
            hide();
        }
    };
    const handleUpdatePosition = () => {
        handleEditorChange();
    };
    editor.on('idlechange', handleEditorChange);
    editor.on('resize', handleUpdatePosition);
    editor.on('scroll', handleUpdatePosition);
    editor.on('blur', hide);
    editor.on('beforedestroy', () => {
        show.clean();
    });
    return bubble;
};
//# sourceMappingURL=link-bubble-toolbar.js.map